module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-01-7cd5cb95f4d799d95434f8f0e6a807c9.png";